export const isFullStatic = false
export const staticPath = "/opt/atlassian/pipelines/agent/build/node_modules/.cache/nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"